<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary">
            <div class="row">
              <div class="col-8 d-flex align-items-center gap-3">
                <div>
                  <h4 class="card-title mt-0">Todo List</h4>
                  <p class="card-category">Manage your todos</p>
                </div>
                <div class="flex-grow-1" style="max-width: 300px;">
                  <app-search [(value)]="searchTerm"
                              (valueChange)="onSearchChange()"
                              placeholder="Search">
                  </app-search>
                </div>
              </div>
              <div class="col-4 text-end">
                <button mat-raised-button type="button" class="btn btn-success pull-right" [routerLink]="['/todos/create']">Add New Todo</button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover table-striped">
                <thead class=" text-primary">
                    <th>ID</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th style="width: 130px;">Due Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                </thead>
                <tbody>
                  <tr *ngFor="let todo of todos">
                    <td>{{ todo.id }}</td>
                    <td>{{ todo.title }}</td>
                    <td>{{ todo.description || '-' }}</td>
                    <td>{{ todo.dueDate ? (todo.dueDate | date:'EEE, dd-MMM-yyyy') : '-' }}</td>
                    <td>{{ todo.isCompleted ? 'Done' : 'Pending' }}</td>
                    <td>
                      <i class="material-icons text-danger" style="cursor: pointer;" (click)="deleteTodo(todo.id)">delete</i>
                      <i class="material-icons text-warning" style="cursor: pointer;" [routerLink]="['/todos/edit', todo.id]">edit</i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <mat-paginator [length]="totalItems"
                             [pageSize]="pageSize"
                             [pageSizeOptions]="[5, 10, 25, 50]"
                             (page)="onPageChange($event)">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
